import { render, staticRenderFns } from "./BillingMultipliers.vue?vue&type=template&id=15f069ec&scoped=true"
import script from "./BillingMultipliers.vue?vue&type=script&lang=ts"
export * from "./BillingMultipliers.vue?vue&type=script&lang=ts"
import style0 from "./BillingMultipliers.vue?vue&type=style&index=0&id=15f069ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f069ec",
  null
  
)

export default component.exports